import { render, staticRenderFns } from "./ProductUpgradeOptions.vue?vue&type=template&id=a5e73bd8&scoped=true&"
import script from "./ProductUpgradeOptions.vue?vue&type=script&lang=js&"
export * from "./ProductUpgradeOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpgradeOptions.vue?vue&type=style&index=0&id=a5e73bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e73bd8",
  null
  
)

export default component.exports